import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Table } from "reactstrap";
import FormattedNumber from "../../FormattedNumber";

const VolumeDiscountTable = ({ volumePrices }, context) => {
  // Fetch the language from the Redux store
  const language = useSelector((state) => state.i18nState.lang);

  return (
    <div>
      <h2 className="h4">{context.t("Volumediscount available")}</h2>
      <p>
        <strong>{context.t("Buy more, save more")}</strong>
        <br />
        {context.t(
          "Volume discount starts at the second item! The discount is already subtracted in the previewed price."
        )}
        <br />
      </p>
      <Table className="small" hover>
        <thead>
          <tr>
            <th>{context.t("amount")}</th>
            <th>{context.t("discount")}</th>
          </tr>
        </thead>
        <tbody>
          {volumePrices &&
            volumePrices?.map((volume_price) => {
              return (
                <tr key={volume_price.attributes.range}>
                  <td>
                    {context.t("from")}{" "}
                    {volume_price.attributes.range.split("..")[0]}{" "}
                    {context.t("units")}
                  </td>
                  <td className="text-success">
                    <strong>
                      <FormattedNumber
                        value={volume_price.attributes.amount * 100}
                        language={language}
                        unit="%"
                        decimals={0}
                      />{" "}
                      {context.t("discount")}
                    </strong>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
};

VolumeDiscountTable.propTypes = {
  productType: PropTypes.string.isRequired,
};

/**  define proptype for the 'translation' function  */
VolumeDiscountTable.contextTypes = {
  t: PropTypes.func,
};

export default VolumeDiscountTable;
